/**
 * Copyright (c) 2020, 2021, 2023, 2024 Visa, Inc.
 *
 * This source code is licensed under the MIT license
 * https://github.com/visa/visa-chart-components/blob/master/LICENSE
 *
 **/
bar-chart {
  .annotations {
    pointer-events: none;
    .handle {
      pointer-events: all;
    }
  }

  .screen-reader-info {
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  .vcc-style-visibility-hidden {
    visibility: hidden;
  }

  .vcc-style-display-none {
    display: none;
  }

  .vcc-style-display-block {
    display: block;
  }

  .vcc-style-point-events-none {
    pointer-events: none;
  }

  .vcc-style-cursor-pointer {
    cursor: pointer;
  }

  .vcc-style-cursor-default {
    cursor: default;
  }

  .data-table-link {
    color: #767676;
    text-decoration: none;
    font-size: 12px;
    margin-left: 5%;
  }

  .hidden {
    display: none;
  }

  cursor: default;
  .light {
    .grid {
      line {
        stroke: #c9c9c9;
        stroke-opacity: 1;
        stroke-width: 0.8;
        // shape-rendering: crispEdges;
        // stroke-dasharray: 4, 4;
      }
      path {
        stroke-width: 0;
      }
    }
    .axis {
      font-size: 12px;
      .tick {
        text {
          fill: #767676;
        }
        line {
          stroke: #767676;
        }
      }

      &-label {
        // axis label
        text-anchor: middle;
        font: 1rem sans-serif;
      }
      &-mark {
        // axis mark
        color: #949494;
        stroke-width: 2px;
      }
    }

    .y.axis {
      path {
        stroke: #767676;
        opacity: 0;
      }
    }
    .x.axis {
      path {
        stroke: transparent;
      }
    }

    .o-layout--chart {
      .bar-dataLabel-vertical {
        // fill: #767676;
        text-anchor: middle;
      }
      .bar-dataLabel-horizontal {
        // fill: #767676;
        text-anchor: start;
      }
    }
  }
  .dark {
    .grid {
      line {
        stroke: lightgrey;
        stroke-opacity: 0.7;
        shape-rendering: crispEdges;
      }
      path {
        stroke-width: 0;
      }
    }
    .axis {
      font-size: 12px;
      .tick {
        line {
          stroke: lightgrey;
        }
        text {
          fill: grey;
        }
      }
      path {
        stroke: black;
      }

      &-label {
        text-anchor: middle;
        font: 1rem sans-serif;
      }
    }
    .o-layout--chart svg {
      background: black;
      .bar-dataLabel-vertical {
        text-anchor: middle;
      }
      .bar-dataLabel-horizontal {
        text-anchor: start;
      }
    }
  }

  //TBD: add color based on scheme
  // .r.axis circle {
  //   stroke: #cccccc;
  //   stroke-width: 1px;
  //   fill: none;
  // }

  //Text alignment, not impacted by color theme
  // .a.axis text {
  //   text-anchor: middle;
  //   font-size: 10pt;
  // }
  //
  // .r.axis text {
  //   text-anchor: end;
  //   font-size: 8pt;
  // }
}
